// hooks/useFormViewer/submitFunnel.ts — submitRpc.ts split (event funnel Meta pasca-order)
import { fireFormFunnelEvent } from '../../../../utils/funnelPixels';

export function fireSubmitFunnelEvent(form: any, globalTrackingSettings: any, orderId: string, args: {
    orderTotal: number; email?: string; phone?: string; name?: string;
}): void {
    // Fire event funel Meta (AddToCart/InitiateCheckout) — intent nyata, bukan view. Otomatis value + AAM.
    const fn = args.name ? String(args.name).trim().split(/\s+/)[0] : undefined;
    const ln = args.name ? String(args.name).trim().split(/\s+/).slice(1).join(' ') : undefined;
    fireFormFunnelEvent(form, globalTrackingSettings, orderId, {
        value: args.orderTotal,
        email: args.email || undefined,
        phone: args.phone || undefined,
        firstName: fn || undefined,
        lastName: ln || undefined,
    });
}
